module.exports = __webpack_public_path__ + "img/water-meter-cold-lg.0f2f1acf.svg";